export class MongoBase {
  //  InternalId: string = '';
  CreatedBy: string = '';
  CreatedOn: Date = new Date();
  UpdatedBy: string = '';
  UpdatedOn: Date = new Date();
  Visible: number;
}
